import React, { useCallback, useEffect, useState } from 'react';
import { VIDEO_LOADING_STATUS } from 'utils/constant';
import VideoBlockContainer from './VideoBlockContainer';

const VideoBlock = React.forwardRef(({ videos }, ref) => {
	const [allVideos, setAllVideos] = useState(null);
	const [filteredAllVideos, setAllFilteredVideos] = useState(null);
	const [renderedVideos, setRenderedVideos] = useState(null);
	const [videoLoadingStatus, setVideoLoadingStatus] = useState(null);
	const [currentActiveVideoIndex, setCurrentActiveVideoIndex] = useState(0);
	const [currentRenderedVideoIndex, setCurrentRenderedVideoIndex] = useState(0);

	const createVideosArray = useCallback(() => {
		const clonedVideos = [...allVideos];
		const firstVideoIndex = Math.floor(Math.random() * clonedVideos.length);
		const firstVideoElement = clonedVideos.splice(firstVideoIndex, 1);

		setAllFilteredVideos(firstVideoElement.concat(clonedVideos));
		setRenderedVideos(firstVideoElement);

		const videoStatus = allVideos.map(() => {
			const data = {
				status: VIDEO_LOADING_STATUS.pending,
			};

			return data;
		});

		setVideoLoadingStatus(videoStatus);
	}, [allVideos]);

	const renderNewVideo = useCallback(() => {
		if (
			videoLoadingStatus[currentRenderedVideoIndex].status === VIDEO_LOADING_STATUS.loaded &&
			renderedVideos.length - 1 <= filteredAllVideos.length - 1
		) {
			if (currentRenderedVideoIndex + 1 <= filteredAllVideos.length - 1) {
				const nextRenderedVideoIndex = currentRenderedVideoIndex + 1;
				const newVideo = structuredClone(filteredAllVideos[nextRenderedVideoIndex]);
				const updatedActiveVideos = [...renderedVideos];

				updatedActiveVideos.push(newVideo);

				setRenderedVideos(updatedActiveVideos);
				setCurrentRenderedVideoIndex(nextRenderedVideoIndex);
			}
		}
	}, [currentRenderedVideoIndex, filteredAllVideos, renderedVideos, videoLoadingStatus]);

	useEffect(() => {
		if (videos && videos.length > 1) {
			setAllVideos(videos);
		}
	}, [videos]);

	useEffect(() => {
		if (!videoLoadingStatus && allVideos) {
			createVideosArray();
		}
	}, [allVideos, createVideosArray, videoLoadingStatus]);

	useEffect(() => {
		if (videoLoadingStatus && filteredAllVideos) {
			renderNewVideo();
		}
	}, [videoLoadingStatus, filteredAllVideos, renderNewVideo]);

	return (
		<div className="video_block" ref={ref}>
			{renderedVideos && renderedVideos.length
				? renderedVideos.map(({ mov, webm }, index) => {
						return (
							<VideoBlockContainer
								key={index}
								srcMov={mov}
								srcWebm={webm}
								videoIndex={index}
								videoLoadingStatus={videoLoadingStatus}
								renderedVideos={renderedVideos}
								setVideoLoadingStatus={setVideoLoadingStatus}
								currentActiveVideoIndex={currentActiveVideoIndex}
								setCurrentActiveVideoIndex={setCurrentActiveVideoIndex}
							/>
						);
					})
				: null}
		</div>
	);
});

export default VideoBlock;
